import { useState } from 'react';
import { Button, Alert } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import ProductStudioModeSelector from './ProductStudioModeSelector';
import ProductNatureCards from './ProductNatureCards';
import { DEFAULT_CREATION_MODE, getNature } from '../productStudioModes';

// ─────────────────────────────────────────────────────────────────
// Entry screen shown on /erp/masters/items/studio/new BEFORE the
// user has picked a mode + nature.
//
// Asks "What do you want to create?" — exposes:
//   • Mode picker (Quick / Guided / Advanced; Quick is default)
//   • Nature cards (Glass / Profile / Hardware / Jobwork / Trading /
//     Ecommerce)
//
// On Start, calls `onStart({ mode, nature })`. The parent then
// applies smart defaults and renders the chosen form. Until the user
// clicks Start, no Form state is touched.
// ─────────────────────────────────────────────────────────────────

export default function ProductStudioEntryScreen({ onStart }) {
  const [mode, setMode]     = useState(DEFAULT_CREATION_MODE);
  const [nature, setNature] = useState(null);

  const canStart = Boolean(nature);
  const natureLabel = (getNature(nature) && getNature(nature).label) || null;

  return (
    <div className="erp-studio-entry">
      <header className="erp-studio-entry__header">
        <h1>What do you want to create?</h1>
        <p>Pick how detailed you want to be, then choose what kind of item this is.</p>
      </header>

      <section className="erp-studio-entry__section">
        <div className="erp-studio-entry__section-label">1. Creation mode</div>
        <ProductStudioModeSelector value={mode} onChange={setMode} />
      </section>

      <section className="erp-studio-entry__section">
        <div className="erp-studio-entry__section-label">2. Item nature</div>
        <ProductNatureCards value={nature} onChange={setNature} />
      </section>

      {nature ? (
        <Alert
          type="info"
          showIcon
          style={{ marginTop: 16, fontSize: 12.5 }}
          message={
            <span>
              You picked <strong>{natureLabel}</strong>.
              {' '}Sensible flag defaults will be pre-applied when you start. You can change anything.
            </span>
          }
        />
      ) : null}

      <div className="erp-studio-entry__footer">
        <Button
          type="primary"
          size="large"
          icon={<ArrowRightOutlined />}
          disabled={!canStart}
          onClick={() => onStart({ mode, nature })}
        >
          Start
        </Button>
      </div>
    </div>
  );
}
